import PcResponseForm from "~/components/database/detail/response-modal-content/response-form/PcResponseForm";
import SpResponseForm from "~/components/database/detail/response-modal-content/response-form/SpResponseForm";
import { Props } from "~/components/database/detail/response-modal-content/response-form/lib";
import { updateResponseAnswer } from "~/components/database/detail/response-modal-content/response-form/lib";
import useIsSpMode from "~/lib/client/hooks/useIsSpMode";

/**
 * PC&SPの共通コンポーネント
 * @param props
 * @constructor
 */
const ResponseForm = (props: Props) => {
  const isSpMode = useIsSpMode();
  if (typeof isSpMode === "undefined") return null;

  return isSpMode ? (
    <SpResponseForm {...props} />
  ) : (
    <PcResponseForm {...props} />
  );
};

export default ResponseForm;
export { updateResponseAnswer };
